// extracted by mini-css-extract-plugin
export var button = "_bf-0";
export var icon = "_bf-1";